import type { OnTrack } from '../index.js'
import type { WorkerTier } from '../../core/index.js'
import { TIER_HEX, TIER_LABELS } from '../../core/index.js'
import { onTrackExplanation } from './ScoreStanding.js'

/**
 * The table-row form of the "on track" label: beside a tier, the tier the
 * worker's running score would set at close, when that is a different one.
 * Renders nothing when the two agree, so most rows stay as they were.
 */
export function OnTrackHint({ tier, onTrack }: { tier: WorkerTier; onTrack: OnTrack | null | undefined }) {
  if (!onTrack || onTrack.tier === tier) {
    return null
  }
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-px rounded-full text-[9px] font-bold whitespace-nowrap"
      style={{ color: TIER_HEX[onTrack.tier], border: `1px dashed ${TIER_HEX[onTrack.tier]}` }}
      title={onTrackExplanation(tier, onTrack) ?? undefined}
    >
      <span aria-hidden="true">→</span>
      <span className="sr-only">on track for</span>
      {TIER_LABELS[onTrack.tier]} at close
    </span>
  )
}
